export default __webpack_public_path__ + "static/media/i2.771dfca5.png";